import React from 'react'
//Helpers
import { RealEstateDataPageComponentData } from 'types'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import GridImageText_1 from '@boilerplates/gridImageText/1'
import { text } from 'stream/consumers'
import { getPhotos } from '@helpers/helper.rendering'
interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const DevelopmentGridImageText_2 = ({
  developmentID,
  global_data,
  upperCaseLink,
}: CombinedProps) => {
  const { data: allDevelopmentData, isLoading } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )

  function asignarTextoALasImagenes() {
    let currentPhotoIndex = 0
    const result: { image: string; description: string }[] = []
    for (const text of segmentDescription()) {
      if (
        getPhotos(allDevelopmentData?.photos).filter((photo) => photo.is_front_cover === false)[
          currentPhotoIndex
        ]?.image
      ) {
        result.push({
          image: getPhotos(allDevelopmentData?.photos).filter(
            (photo) => photo.is_front_cover === false,
          )[currentPhotoIndex]?.image,
          description: text,
        })
        currentPhotoIndex++
      }
    }

    return result
  }

  function segmentDescription() {
    const MIN_LENGTH = 400
    let segments = []
    let currentSegment = ''
    if (!allDevelopmentData?.description) return []
    const sentences = allDevelopmentData?.description.replaceAll('&nbsp;', ' ').split('.')

    for (let sentence of sentences) {
      if (sentence.trim().length === 0) continue // Ignora oraciones vacías

      if ((currentSegment + sentence).length >= MIN_LENGTH) {
        currentSegment += sentence + '.'
        segments.push(currentSegment.trim())
        currentSegment = ''
      } else {
        currentSegment += sentence + '.'
      }
    }

    // Agrega el último segmento si no está vacío
    if (currentSegment.trim().length > 0) {
      segments.push(currentSegment.trim())
    }

    return segments
  }

  function makeItems() {
    const textsImages = asignarTextoALasImagenes()

    return textsImages.map((element) => ({ paragraph: element.description, image: element.image }))
  }

  return (
    <GridImageText_1
      title={allDevelopmentData?.publication_title || 'Cargando..'}
      global_data={global_data}
      upperCaseLink={upperCaseLink}
      items={makeItems()}
    />
  )
}

export default DevelopmentGridImageText_2
